import { gql } from "@apollo/client";
import { API } from "api/API";
import axios from "axios";

export const getDowntimeSummaryByFailureTypeMillDashboard = gql`
    query getDowntimeSummaryByFailureTypeMillDashboard(
        $where: event_failure_code_summary_per_mc_bool_exp
        $whereFailureType: failure_type_bool_exp
    ) {
        failure_type(where: $whereFailureType) {
            failure_type_id
            name
            color_code
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    name
                }
                translated_name
            }
            event_failure_code_summary_per_mcs_aggregate(where: $where) {
                aggregate {
                    sum {
                        occurrences
                        seconds
                    }
                }
            }
        }
    }
`;

export const getDowntimeSummaryByFailureCodeMillDashboard = gql`
    query getDowntimeSummaryByFailureCodeMillDashboard(
        $where: event_failure_code_summary_per_mc_bool_exp
        $whereFailureCode: failure_code_bool_exp
    ) {
        failure_code(where: $whereFailureCode) {
            failure_code_id
            name
            default_failure_code_translations {
                failure_code_id
                language {
                    language_id
                    name
                }
                translated_name
            }

            summary: event_failure_code_summary_per_mcs_aggregate(where: $where) {
                aggregate {
                    sum {
                        seconds
                        occurrences
                    }
                }
            }
        }
    }
`;

export const getDowntimeSummarySecondaryFailureCodeMillDashboard = gql`
    query getDowntimeSummarySecondaryFailureCodeMillDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        downtimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureTypePerMachineCenterMillDashboard = gql`
    query getDowntimeSummaryFailureTypePerMachineCenterMillDashboard(
        $where: event_failure_type_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_type(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureCodePerMachineCenterMillDashboard = gql`
    query getDowntimeSummaryFailureCodePerMachineCenterMillDashboard(
        $where: event_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummarySecondaryFailureCodePerMachineCenterMillDashboard = gql`
    query getDowntimeSummarySecondaryFailureCodePerMachineCenterMillDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getUptimesVsDowntimesTotalsPerMachineCenterMillDashboard = gql`
    query getUptimesVsDowntimesTotalsPerMachineCenterMillDashboard(
        $whereMachineCenter: machine_center_bool_exp
        $whereDowntimes: event_failure_code_summary_per_mc_bool_exp
        $whereUptimes: event_failure_code_summary_per_mc_bool_exp
    ) {
        downtimes: machine_center(where: $whereMachineCenter) {
            machine_center_id
            production_line {
                production_line_id
                name
                code
            }
            summary: event_failure_code_summary_per_mcs_aggregate(where: $whereDowntimes) {
                aggregate {
                    sum {
                        seconds
                        occurrences
                    }
                }
            }
        }
        uptimes: machine_center(where: $whereMachineCenter) {
            machine_center_id
            production_line {
                production_line_id
                name
                code
            }
            summary: event_failure_code_summary_per_mcs_aggregate(where: $whereUptimes) {
                aggregate {
                    sum {
                        seconds
                        occurrences
                    }
                }
            }
        }
    }
`;

export const getTotalDowntimeSummaryByCodePerFunctionalLocationMillDashboard = gql`
    query getTotalDowntimeSummaryByCodePerFunctionalLocationMillDashboard(
        $where: event_functional_location_summary_per_mc_bool_exp
        $whereFunctionalLocation: functional_location_bool_exp
    ) {
        functional_location(where: $whereFunctionalLocation) {
            functional_location_id
            translation {
                id
                translation_names {
                    name
                    language_id
                }
            }
            summary: event_functional_location_summary_per_mcs_aggregate(where: $where) {
                aggregate {
                    sum {
                        seconds
                        occurrences
                    }
                }
            }
        }
    }
`;

export const get13WeekDowntimeSummaryTotalsByFailureCode = gql`
    query get13WeekDowntimeSummaryTotalsByFailureCode(
        $input_date: timestamptz!
        $where: event_failure_code_summary_totals_per_mc_13_week_trend_bool_exp
    ) {
        weekly_downtime: get_13_week_downtime_summary_totals_by_failure_code(
            where: $where
            args: { input_date: $input_date }
            order_by: { week_date: desc }
        ) {
            week_date
            week_seconds
            week_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const get13WeekDowntimeSummaryTotalsBySecondaryFailureCode = gql`
    query get13WeekDowntimeSummaryTotalsBySecondaryFailureCode(
        $input_date: timestamptz!
        $where: event_secondary_failure_code_summary_totals_per_mc_13_week_tren_bool_exp
    ) {
        weekly_downtime: get_13_week_downtime_summary_totals_by_secondary_failure_code(
            where: $where
            args: { input_date: $input_date }
            order_by: { week_date: desc }
        ) {
            week_date
            week_seconds
            week_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;
interface IExcelFilters {
    startDateRange: Date;
    endDateRange: Date;
    shiftId?: number;
    functionalLocationId?: number;
    failureTypeIds?: number[];
    failureCodeIds?: number[];
    operatorId?: number;
    machineCenterIds?: number[];
    productionLineIds?: number[];
    millId: number;
    languageCode: string;
}

const APIInstance = new API();

export const getEventReportDetailsExcelFile = async (
    filters: IExcelFilters,
    fileNamePlaceholder: string,
): Promise<void> => {
    try {
        const url = `${APIInstance.api_root}/query/generate-event-report-details-excel`;
        const response = await axios.post<any>(
            url,
            { filters },
            {
                responseType: "blob",
            },
        );

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = fileNamePlaceholder;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error(error);
        throw error;
    }
};
